<template>
  <DialogHeader>
    <template #right>
      <div class="font-medium text-green-900 cursor-pointer" @click="close()">
        Okay
      </div>
    </template>
    Can't do this here
  </DialogHeader>
  <DialogContent>
    Please go to your {{ store }} settings in order to resubscribe to your
    {{ billingStore.billing?.plan.name }} plan.
  </DialogContent>
  <DialogFooter>
    <UiButton class="w-full" primary @click="handleClick">
      Go to {{ store }} settings
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { useBillingStore } from '@/features/billing/store'
import { computed } from 'vue'
import { PlatformType } from '@/shared/graphql/legacy/generated'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'

const { close } = useDialog()

const billingStore = useBillingStore()
const webviewStore = useWebviewStore()

const store = computed(() =>
  billingStore.billing?.plan.platform === PlatformType.Apple
    ? 'Apple App Store'
    : 'Google Play'
)

const handleClick = () => {
  close()

  webviewStore.postMessage({
    type: NativeActionsEnum.OpenStoreSettings,
  })
}
</script>
